<template>
  <div>
    <el-drawer
      v-if="visible"
      visible
      show-close
      :size="1000"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          :custCode="custCode"
          :custApprovalRequestCode="custApprovalRequestCode"
          :custApprovalRequestType="custApprovalRequestType"
          :custApprovalNode="custApprovalNode"
          @close="close"
          @reload="$emit('reload')"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import Main from './main.vue'
export default {
  mixins: [EditLoading],
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    custCode: { type: String, default: '' },
    title: { type: String, default: '' },
    custApprovalRequestCode: { type: String, default: '' },
    custApprovalRequestType: { type: String, default: '' },
    custApprovalNode: { type: String, default: '' },
  },
  data() {
    return {}
  },
  computed: {
    disabled() {
      return this.type === 'detail'
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 10px;
}
</style>
